import React from 'react';
import { Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import successImg from 'img/success-img.svg';
import { Button } from 'components/Button';
import { NoteCorrectionSuccessProps } from '../interface';
import { useDispatch } from 'react-redux';

const NoteCorrectionSuccess: React.FC<NoteCorrectionSuccessProps> = (props) => {
  const { protocolNumber } = props;
  const dispatch = useDispatch();

  return (
    <Column
      className="bg-white background-absolute-page p-3"
    >
      <Column
        className="bg-white w-100 flex-1 h-100 align-center justify-center"
      >
        <img src={successImg} alt="" />
        <Text className="mt-5 color-blue-gray">
          Sua solicitação para a alteração da nota foi enviada com sucesso.
        </Text>
        <Text className="color-blue-gray">
          Foi aberto o protocolo {protocolNumber} para acompanhar o andamento do processo
        </Text>
        <Button className="outline mt-5" width="auto" onClick={() => dispatch({ type: 'CLOSE_SLIDER' })}>
          <Text className="color-primary font-bold px-2">
            Fechar
          </Text>
        </Button>
      </Column>
    </Column>
  );
};

export default NoteCorrectionSuccess;